module.exports = __webpack_public_path__ + "static/media/assign-white.1e87a12f.svg";